export default "__VITE_ASSET__CnhQm0po__"